const useRandomNumber = (maxRange: number) => Math.floor(Math.random() * maxRange) + 1;

export { useRandomNumber };
